import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import CashflowStore from 'stores/CashflowStore'
import PrintPreview from './PrintPreview';

const DEFAULT_ROW = 21
class PrintReportTJYIncentiveExpenseInsurance extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:false, 
      data:[],
      dataList:[],
      report_title:'กำลังดึงข้อมูล..'
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    this.loadData()
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getMoneySpent() {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      sum = parseFloat(sum) + parseFloat(item.amount)
    })
    if (isNaN(sum)){
      sum = 0
    }
    return sum
  }

  loadData() {
    let {park,noPark,paidYet,noPaidYet,year,month,payeeValue,incentiveType} = this.props
    let params = {year:year,month:month,category:incentiveType,payee_id:payeeValue}
    let filter = {park:park,no_park:noPark,paid_yet:paidYet,no_paid_yet:noPaidYet}
    params = Object.assign(params,filter)
    CashflowStore.loadCashflowIncentiveExpenseRecord(params,(result)=>{
      this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
    },()=>{
      this.setState({data:[],report_title:'ไม่พบข้อมูล'})
    })
  }

  renderRowData(data,indexs) {
    if (data.length===0) {
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    } else {
      return data.map((item, index) => (
          <tr key={index}>
            <td className='text-center'>{(indexs*40)+index+1}</td>
            <td className='text-center'>{item.park_status==='park'?'จอด':'ไม่จอด'}</td>
            <td className='text-center'>{item.work_no}</td>
            <td className='text-center'>{item.car_registration_no}</td>
            <td className='text-center'>{item.car_info}</td>
            <td className='text-center'>{item.insurer_name}</td>
            <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
          </tr>
      ))
    }
}

  renderTable(item,index,length) {
    return(
        <div>   
          <table className='table table-print-report-incentive'>   
            <tbody>
              {/* <tr>
                <td rowSpan={2} className='text-center' style={{width:'50px'}}>ลำดับ</td>
                <td rowSpan={2} className='text-center' style={{width:'200px'}}>ยี่ห้อรถ</td>
                <td rowSpan={2} className='text-center' style={{width:'150px'}}>เลขทะเบียน</td>
                <td rowSpan={2} className='text-center' style={{width:'180px'}}>เลขรับแจ้งเลขเคลน</td>
                <td rowSpan={2} className='text-center' style={{width:'180px'}}>เลขกรมธรรม์</td>
                <td colSpan={2} className='text-center'>ชนิดรถ</td>
                <td className='text-center'>บมจ.วิริยะ</td>
                <td rowSpan={2} className='text-center' style={{width:'150px'}}>หมายเหตุ</td>
              </tr>
              <tr>
                <td className='text-center' style={{width:'80px'}}>ประกัน</td>
                <td className='text-center' style={{width:'80px'}}>คู่กรณี</td>
                <td className='text-center' style={{width:'80px'}}>ศูนย์</td>
              </tr> */}
              <tr>
                <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                <td className='text-center' style={{ width: '65px' }}>จอด ?</td>            
                <td className='text-center' style={{ width: '100px' }}>เลขรับแจ้ง</td>
                <td className='text-center' style={{ width: '100px' }}>ทะเบียนรถ</td>
                <td className='text-center' style={{ width: '150px' }}>ยี่ห้อ</td>            
                <td className='text-center' style={{ width: '250px' }}>ประกัน</td>
                <td className='text-right' style={{ width: '100px' }}>ค่าใช้จ่าย</td>
              </tr>
              {this.renderRowData(item,index,length)}
              {length-1===index?
              <tr>
                <td className='text-center' colSpan={6}></td>           
                <td className='text-right' >{this.getNumberFormat(this.getMoneySpent())}</td>
              </tr>
              :''}
            </tbody>
          </table> 
        </div>
    )
  }

  getPagination(data) {
    let newData = []
    let allData = []
    let checkRow = 0
    data.forEach(function(item,index) {
        if (checkRow<DEFAULT_ROW)
          checkRow++
          newData.push(item)

        if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
          allData.push(newData)
          checkRow = 0
          newData = []
        }
    })  
    return allData
  }

  renderComponentPage(item,index,length) {
    return(  
        <div className='font-print' key={index}>
            <header className="text-center">
                <h2>{this.props.title}</h2>
            </header>
            <div>
                {this.renderTable(item,index,length)}
            </div>
        </div>
    )    
}

renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
}

  render() {
          let {loading,dataList} = this.state
          if (dataList.length==0) {
              return(
                <PrintPreview 
                  loading={loading}
                  leftBarTitle={this.props.title}
                >
                  {this.renderNoData()}    
                </PrintPreview>
              )
          } else {
              return(
                <PrintPreview 
                  loading={loading}
                  leftBarTitle={this.props.title}
                >
                  {
                    dataList.map((item,index)=>{
                      return(
                        this.renderComponentPage(item,index,dataList.length)
                      )
                    })   
                  }
                </PrintPreview>
              )
          }
  }
}  

PrintReportTJYIncentiveExpenseInsurance.defaultProps = {
  title: 'รายงานรถเข้าซ่อมประจำวัน บมจ. วิริยะศูนย์ลำพูน',  
  mode : '1'
}
export default PrintReportTJYIncentiveExpenseInsurance;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportTJYIncentiveExpenseInsurance.js